var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8881 3.80718C3.95335 3.88227 4.01194 3.95035 4.06357 4.01073C4.18292 3.83806 4.34521 3.60401 4.54627 3.31559C5.00984 2.65068 5.67956 1.69689 6.50466 0.540901C6.82789 0.0880191 7.45163 -0.176567 8.01488 0.135943C8.34982 0.321773 8.74951 0.610074 9.06431 1.03915C9.37654 1.46471 9.28453 1.99973 9.04126 2.36828C7.21495 5.13511 5.89681 6.82037 5.16304 7.69724C4.68305 8.27088 3.84457 8.31067 3.30585 7.79982C2.59809 7.12869 1.46965 5.99472 0.295865 4.55718C-0.0343089 4.15282 -0.132045 3.53925 0.23132 3.07366C0.466979 2.7717 0.733365 2.51582 0.970361 2.31572C1.49387 1.87374 2.22538 1.99296 2.65899 2.45229C3.18108 3.00532 3.59968 3.47516 3.8881 3.80718Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5f477fe34f79dac68542e01725d64b08.svg";
export { ForwardRef as ReactComponent };